module.exports = __webpack_public_path__ + "img/mp3img.e0adca51.png";